import React from 'react';
import Icons from './Icons';

export default function KontributorCard() {
  return (
    <div className="grid lg:grid-cols-4 sm:grid-cols-2 lg:gap-4 gap-8 mt-[8%] mb-28">
      <div className="flex flex-col items-center grow border border-[#DDDDDD] text-center rounded p-[20%]">
        <Icons src="/assets/images/icon-1.svg" alt="icon-1" />
        <div className="my-4">
          <h2>Buat Akun</h2>
          <h5>Tujuan buat akun adalah supaya kamu bisa mengakses fitur lengkap explore Tegal</h5>
        </div>
      </div>
      <div className="flex flex-col items-center grow border border-[#DDDDDD] text-center rounded p-[20%]">
        <Icons src="/assets/images/icon-2.svg" alt="icon-2" />
        <div className="my-4">
          <h2>Buat Akun</h2>
          <h5>Tujuan buat akun adalah supaya kamu bisa mengakses fitur lengkap explore Tegal</h5>
        </div>
      </div>
      <div className="flex flex-col items-center grow border border-[#DDDDDD] text-center rounded p-[20%]">
        <Icons src="/assets/images/icon-3.svg" alt="icon-3" />
        <div className="my-4">
          <h2>Buat Akun</h2>
          <h5>Tujuan buat akun adalah supaya kamu bisa mengakses fitur lengkap explore Tegal</h5>
        </div>
      </div>
      <div className="flex flex-col items-center grow border border-[#DDDDDD] text-center rounded p-[20%]">
        <Icons src="/assets/images/icon-4.svg" alt="icon-4" />
        <div className="my-4">
          <h2>Buat Akun</h2>
          <h5>Tujuan buat akun adalah supaya kamu bisa mengakses fitur lengkap explore Tegal</h5>
        </div>
      </div>
    </div>
  );
}
